/* eslint-disable */
import Vue from 'vue'
import Utils from '../../utils/utils'
/* eslint-enable */
export function queryModelAnaByType (type) {
  return Vue.http.get(Utils.paths.ProductInfo.queryModelAnaByType + '?product=' + type, {emulateJSON: false}, {headers: {'ContentType': 'application/json'}})
}
export function queryModelAnaByTypeAndParts (type, part) {
  return Vue.http.get(Utils.paths.ProductInfo.queryModelAnaByTypeAndParts + '?product=' + type + '&part=' + part, {emulateJSON: false}, {headers: {'ContentType': 'application/json'}})
}
export function queryModel (val) {
  return Vue.http.get(Utils.paths.ProductInfo.queryModel + '?model=' + val, {emulateJSON: false}, {headers: {'ContentType': 'application/json'}})
}

export function queryProductLineByMTBrandKoala (MT, Brand, TrackingNumber) {
  return Vue.http.get(Utils.paths.ProductInfo.queryProductLineByMTBrandKoala + '?MT=' + MT + '&Brand=' + Brand + '&TrackingNumber=' + TrackingNumber, {emulateJSON: false}, {headers: {'ContentType': 'application/json'}})
}




// WEBPACK FOOTER //
// ./src/api/modules/RequestPI.js